import styled from "styled-components";

type Props = { signingIn: boolean };

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 999;
  font-family: Kanit;
  background: transparent;
`;

export const SignUpContainer = styled.div<Props>`
  position: absolute;
  top: 0;
  height: 100%;
  width: 50%;
  left: 0;
  transition: all 0.6s ease-in-out;
  opacity: 0;
  z-index: 1;
  transform: translateX(50%);

  ${({ signingIn }) =>
    !signingIn &&
    `
      transform: translateX(100%);
      opacity: 1;
      z-index: -5;
    `}
`;

export const SignInContainer = styled.div<Props>`
  position: absolute;
  top: 0;
  height: 100%;
  width: 50%;
  left: 0;
  transition: all 0.6s ease-in-out;
  z-index: 5;
  transform: translateX(0);

  ${({ signingIn }) =>
    !signingIn &&
    `
      transform: translateX(-100%);
      z-index: 1;
    `}
`;

export const Form = styled.div`
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 50px;
  height: 100%;
  text-align: center;
`;

export const Title = styled.h1`
  font-weight: bold;
  margin: 0;
`;

export const Input = styled.input`
  background-color: #eee;
  border: none;
  padding: 12px 15px;
  margin: 8px 0;
  width: 100%;
`;

export const Button = styled.button`
  border-radius: 20px;
  border: 1px solid #ff4b2b;
  background-color: #ff4b2b;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  padding: 12px 45px;
  letter-spacing: 1px;
  text-transform: uppercase;
  transition: transform 80ms ease-in;
  &:active {
    transform: scale(0.95);
  }
  &:focus {
    outline: none;
  }
`;

export const GhostButton = styled(Button)`
  background-color: transparent;
  border-color: #ffffff;
  font-family: Kanit;
`;

export const Anchor = styled.a`
  color: #333;
  font-size: 14px;
  text-decoration: none;
  margin: 15px 0;
`;

export const OverlayContainer = styled.div<Props>`
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
  z-index: 100;

  ${({ signingIn }) =>
    !signingIn &&
    `
      transform: translateX(-100%);
    `}
`;

export const Overlay = styled.div<Props>`
  background: linear-gradient(to right, #d74423, #f29950);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  color: #ffffff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transition: transform 0.6s ease-in-out;
  transform: translateX(0);

  ${({ signingIn }) =>
    !signingIn &&
    `
      transform: translateX(50%);
    `}
`;

export const OverlayPanel = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 40px;
  text-align: center;
  top: 0;
  height: 100%;
  width: 50%;
  transition: transform 0.6s ease-in-out;
`;

export const LeftOverlayPanel = styled(OverlayPanel)<Props>`
  transform: translateX(-20%);
  ${({ signingIn }) =>
    !signingIn &&
    `
      transform: translateX(0);
    `}
`;

export const RightOverlayPanel = styled(OverlayPanel)<Props>`
  right: 0;
  transform: translateX(0);
  ${({ signingIn }) =>
    !signingIn &&
    `
      transform: translateX(20%);
    `}
`;

export const Paragraph = styled.p`
  font-size: 14px;
  font-weight: 100;
  line-height: 20px;
  letter-spacing: 0.5px;
  margin: 20px 0 30px;
`;
